import { render } from "./Views.vue?vue&type=template&id=742cf660&scoped=true"
import script from "./Views.vue?vue&type=script&lang=js"
export * from "./Views.vue?vue&type=script&lang=js"

import "./Views.vue?vue&type=style&index=0&id=742cf660&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-742cf660"]])

export default __exports__